import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import Functions from "./index.function";
const HeadingCom = (props) => {
  const { handleViewMore } = Functions();
  return (
    <div className="flex justify-between items-center w-full">
      <h2
        className={`text-xl sm:text-3xl lg:text-4xl uppercase text-center font-unboundedBold text-secondary cursor-default ${props.navigatelayout}`}
      >
        {props.title}
      </h2>
      <div
        className={`text-secondary font-onestRegular text-sm sm:text-base lg:text-lg flex items-center group hover:text-orangeCrayola ${
          props.to ? "cursor-pointer" : "cursor-default"
        }`}
        onClick={() => handleViewMore(props.to)}
      >
        View More{" "}
        <IoIosArrowRoundForward className="text-secondary text-2xl sm:text-3xl ransition-all duration-300 -rotate-45 group-hover:rotate-0 group-hover:text-orangeCrayola" />
      </div>
    </div>
  );
};
export default HeadingCom;
